<script lang="ts">
import type { MaybeComputedElementRef } from '@vueuse/core';

export interface VectorProps {
  lazy?: boolean;
  url?: string;
  rounded?: boolean;
}
</script>

<script setup lang="ts">
import { ref, onMounted, watchEffect } from 'vue';
import { useElementBounding } from '@vueuse/core';

const props = withDefaults(defineProps<VectorProps>(), {
  lazy: false,
  rounded: false
});

const emit = defineEmits<{
  load: [];
}>();

const root = ref<HTMLImageElement | null>(null);
const hasLoaded = ref(false);
const isPreloading = ref(!props.lazy);

const onLoad = (): void => {
  hasLoaded.value = true;
  emit('load');
};

onMounted(() => {
  const { top } = useElementBounding(root as unknown as MaybeComputedElementRef);

  watchEffect(() => {
    if (props.lazy && !isPreloading.value && top.value) {
      isPreloading.value = hasLoaded.value || top.value < window.innerHeight * 2;
    }
  });

  if (!props.lazy && (root.value as HTMLImageElement)?.complete) {
    onLoad();
  }
});
</script>

<template>
  <img
    ref="root"
    class="block transition-opacity duration-500"
    :class="[
      hasLoaded || props.lazy ? '' : 'opacity-0',
      props.rounded ? 'rounded-xl' : 'rounded-none'
    ]"
    :src="props.url || undefined"
    alt=""
    @load="onLoad"
  />
</template>
